import { render, staticRenderFns } from "./CompactHeaderMenu.vue?vue&type=template&id=7bd8fd1c&scoped=true"
import script from "./CompactHeaderMenu.vue?vue&type=script&lang=js"
export * from "./CompactHeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./CompactHeaderMenu.vue?vue&type=style&index=0&id=7bd8fd1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd8fd1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd8fd1c')) {
      api.createRecord('7bd8fd1c', component.options)
    } else {
      api.reload('7bd8fd1c', component.options)
    }
    module.hot.accept("./CompactHeaderMenu.vue?vue&type=template&id=7bd8fd1c&scoped=true", function () {
      api.rerender('7bd8fd1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layouts/main/components/CompactHeaderMenu.vue"
export default component.exports